export const notZeroValidator = (value) => {
  if (!value) {
    return true
  }
  return (parseInt(value) !== 0)
}
